import React from "react";
import {Link} from "react-router-dom";
import {doctorthumb02} from "../imagepath";
import ImageHospital from "./ImageHospital";
import StarRating from "../util/StarRating";
import "./assets/css/Pagecontent.css"; // Importando o CSS personalizado

const Pagecontent = ({hospital}) => {
    // Verifica se existem imagens associadas ao hospital; caso contrário, usa uma imagem padrão.
    const hospitalImages = hospital?.images?.length > 0 ? hospital.images : [{file: doctorthumb02}];

    return (
        <div className="hospital-card shadow-sm mb-4">
            <div className="card-body">
                <div className="row doctor-widget d-flex align-items-center">
                    <div className="col-8 row doc-info-left">
                        <div className="col-3">
                            <div className=" doctor-img mb-3">
                                <img
                                    src={hospital?.images[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                    alt={hospital?.name}
                                    width={400}
                                    className="img-fluid rounded"
                                />

                            </div>
                        </div>
                        <div className="col-9">
                            <h6 className="doc-name text-primary">
                                {hospital?.name || "Nome não disponível"}
                            </h6>
                            <p className="doc-speciality text-muted">
                                {hospital?.cnpj_fantasy_name || "Especialidade não disponível"}
                            </p>

                            <div className="rating mb-2">
                                <StarRating rating={hospital?.rating || 0}/>
                            </div>

                            <div className="clinic-details">
                                <p className="doc-location text-muted mb-1">
                                    <i className="fa fa-map-marker-alt me-2 text-primary"></i>
                                    {hospital?.street_name}, {hospital?.address_number}, {hospital?.neighborhood_name} -
                                    {hospital?.city?.name || "Cidade não disponível"}, {hospital?.uf || "UF não disponível"}
                                </p>
                                <p className="doc-contact text-muted mb-1">
                                    <i className="fa fa-phone-alt me-2 text-primary"></i>
                                    {hospital?.phone_number || "Telefone não disponível"}
                                </p>
                                <p className="doc-email text-muted mb-1">
                                    <i className="fa fa-envelope me-2 text-primary"></i>
                                    {hospital?.email_address || "E-mail não disponível"}
                                </p>
                                {hospital?.images > 0 && (
                                    <div className="mt-2">
                                        <ImageHospital images={hospital?.images}/>
                                    </div>
                                )}
                            </div>
                        </div>


                    </div>
                    <div className="col-4 doc-info-right text-end">
                        <div className="clini-infos mb-3">
                            <ul className="list-unstyled mb-0">
                                <li>
                                    <i className="far fa-comment text-primary me-2"/>
                                    {hospital?.total_rating || 0} Avaliações
                                </li>
                                <li>
                                    <i className="fa fa-map-marker-alt text-primary me-2"/>
                                    {hospital?.city?.name || "Cidade não disponível"}, {hospital?.uf || "UF não disponível"}
                                </li>
                            </ul>
                        </div>
                        <div className="doctor-action ">
                            <a
                                target="_blank"
                                href={`http://maps.google.com/maps?q=${hospital?.latitude},${hospital?.longitude}`}
                                className="btn btn-outline-primary me-2"
                            >
                                <i className="fa fa-map"></i> Mapa
                            </a>
                            <a
                                href={`mailto:${hospital?.email}`}
                                className="btn btn-outline-success me-2 "
                            >
                                <i className="fa fa-envelope"></i> E-mail
                            </a>
                            <a
                                href={`tel:${hospital?.phone_number}`}
                                className="btn btn-outline-info me-2"
                            >
                                <i className="fa fa-phone"></i> Telefone
                            </a>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pagecontent;
